
  <h1 mat-dialog-title>Select HVAC Contractor</h1>
  <div [formGroup]="hvacForm">

    <mat-form-field style="width:80%">
    <mat-label>HVAC Contractor:{{customer_name}} </mat-label>
    <input id='hvaccontractorfield' matInput placeholder="Type contractor name here" formControlName="customer_id" [matAutocomplete]="hvacid">
    </mat-form-field>

    <mat-autocomplete #hvacid="matAutocomplete" (optionSelected)="onSelectContractor($event.option.value)" [displayWith]="displayContractor">
      <mat-option *ngFor="let contractor of (contractor$ | async)" [value]="contractor">
        <span>{{ contractor.customer_name }}</span>
      </mat-option>
    </mat-autocomplete>

    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button [disabled]="hvacForm.invalid" (click)="onYesClick()">Done</button>
    </div>
  </div>
  